import { useNavigate } from 'react-router-dom';

// Phải custom hook navigate để sử dụng navigate trong trường hợp không phải component
const useNavigation = () => {
  const navigate = useNavigate();
  return navigate;
};

export default useNavigation;
